import React from "react";

import styled from "styled-components";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useTranslation, Trans } from "react-i18next";

import Layout from "../../components/organisms/Layout";
import { fonts } from "../../styles/variables";
import breakpoints from "../../styles/breakpoints";
import urlPatterns from "../../urls";
import dancingCouple from "../../assets/images/elements/dancing-couple.svg";
import NotFoundContent from "../../components/molecules/NotFoundContent";
import { I18N_NAMESPACES } from "../../helpers/constants";
import { usePrerenderReady } from "../../helpers/hooks";

const StyledLink = styled(Link)`
  text-decoration: underline;
  &:hover {
    text-decoration: underline;
  }
`;

const StyledParagraph = styled.p`
  font-family: ${fonts.fontBauMedium};
  font-size: 16px;
  max-width: 60%;
  margin: auto;
  ${breakpoints.smDown} {
    max-width: 100%;
  }
`;

/**
 * 404 page.
 * */
const NotFound = ({ location }) => {
  const { isOldVersion } = (location && location.state) || {};
  const { t } = useTranslation(I18N_NAMESPACES.COMMON);
  usePrerenderReady();

  const versionContext = isOldVersion ? "old" : "default";

  const header = t("common:notFound.header", {
    context: versionContext,
  });

  const paragraph = (
    <StyledParagraph>
      <Trans
        i18nKey="common:notFound.paragraph"
        values={{
          context: versionContext,
        }}
        components={{ a: <StyledLink to={urlPatterns.HOME} /> }}
      />
    </StyledParagraph>
  );

  return (
    // NOT_FOUND has it's own layout. This is due to us not being able to move NOT_FOUND into a switch,
    // since NOT_FOUND is the default if no other paths are found.
    <Layout showBoxAndCartTray={false}>
      <NotFoundContent
        header={header}
        paragraph={paragraph}
        imageSrc={dancingCouple}
        imageAlt={"drunk-tech-team"}
      />
    </Layout>
  );
};

NotFound.propTypes = {
  location: PropTypes.shape({}).isRequired,
};

export default NotFound;
